module.exports = __webpack_public_path__ + "img/3S.72ef2492.png";